<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                Trouwdatum
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Vul hier de trouwdatum in.
                <div class="space10"></div>
                Is er sprake van een geregistreerd partnerschap? Vul dan de datum in waarop dit partnerschap is
                aangegaan.
                Geregistreerd partnerschap is een samenlevingsvorm die wettelijk is geregeld en is vastgelegd bij de
                burgerlijke stand van de gemeente.
            </div>

        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading3">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse3" aria-expanded="false" aria-controls="collapse3">
                Scheidingsdatum
            </button>
        </h2>
        <div id="collapse3" class="accordion-collapse collapse" aria-labelledby="heading3"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Vul de scheidingsdatum in indien er sprake is van:<br/>
                <li class="list">
                    in {{ this.actualYear }} of eerder een echtscheiding is aangevraagd bij de rechter
                </li>
                <li class="list">
                    in {{ this.actualYear }} of eerder een scheiding van tafel en bed is aangevraagd bij de rechter
                </li>
                <li class="list">
                    in {{ this.actualYear }} of eerder een geregistreerd partnerschap heeft beëindigd (met of zonder
                    tussenkomst van de rechter)
                </li>

                <div class="space20"></div>

                Vul hier de datum in waarop:<br/>
                <li class="list">
                    de aangever of de partner het verzoek bij de rechtbank heeft gedaan tot scheiding, scheiding van
                    tafel en bed, of om het geregistreerd partnerschap te laten ontbinden
                </li>
                <li class="list">
                    de beëindiging van het geregistreerd partnerschap in de registers van de burgerlijke stand is
                    opgenomen (zonder tussenkomst van de rechter)
                </li>

            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading4">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse4" aria-expanded="false" aria-controls="collapse4">
                Overlijdensdatum partner
            </button>
        </h2>
        <div id="collapse4" class="accordion-collapse collapse" aria-labelledby="heading4"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Is de partner overleden in {{ this.actualYear }}? Vul dan de overlijdensdatum van de partner in.
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading5">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse5" aria-expanded="false" aria-controls="collapse5">
                Situatie samenwonende partners
            </button>
        </h2>
        <div id="collapse5" class="accordion-collapse collapse" aria-labelledby="heading5"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Partners die een deel van het {{ this.actualYear }} samenwonen kunnen in aanmerking komen voor fiscaal
                partnerschap. <br/>
                Dan dient aan een van de volgende voorwaarden voldaan te zijn:
                <li class="list">
                    Beide partners zijn meerderjarig en hebben samen een notarieel samenlevingscontract.
                </li>
                <li class="list">
                    De partners hebben samen een kind.
                </li>
                <li class="list">
                    Een van de partners heeft een kind van de ander erkend.
                </li>
                <li class="list">
                    De partners zijn bij een pensioenfonds aangemeld als pensioenpartners. Het is niet voldoende als een
                    van beide de ander alleen bij de werkgever heeft aangemeld als pensioenpartner.
                </li>
                <li class="list">
                    De partners zijn samen eigenaar van een eigen woning, waarin ze beiden wonen.
                </li>
                <li class="list">
                    De partners zijn allebei meerderjarig en op het adres waar ze beiden staan ingeschreven in de BRP
                    staat ook een minderjarig kind van 1 van de partners ingeschreven. Let op! Hiervoor gelden
                    uitzonderingen.
                </li>
                <li class="list">
                    De aangever en partner waren in het voorgaande jaar ({{ this.actualYear - 1 }}) ook al fiscale
                    partners.
                </li>

                <div class="space20"></div>
                Woont aangever samen met een eigen kind of met de vader of moeder? En voldoet aangever aan 1 van de
                voorwaarden voor fiscaal partnerschap? Dan zijn ze alleen fiscale partners als ze allebei op 31 december
                van het jaar ervoor 27 jaar of ouder waren.

                <div class="space20"></div>
                Uitgebreidere toelichting op deze onderdelen vind je via onderstaande 'Meer fiscale informatie' op de
                site van de Belastingdienst.
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading6">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse6" aria-expanded="false" aria-controls="collapse6">
                Keuze voor heel jaar fiscaal partnerschap
            </button>
        </h2>
        <div id="collapse6" class="accordion-collapse collapse" aria-labelledby="heading6"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Kies 'Ja' als aangever heel het fiscale jaar met de partner persoon fiscale partners willen zijn. Je mag dan voor
                beide personen samen aangifte doen en bepaalde inkomsten, uitgaven en bezittingen gunstig verdelen. Hierdoor betalen de
                partners vaak minder belasting.

                <div class="space20"></div>
                <b>Wat zijn de gevolgen van fiscaal partnerschap?</b><br/>

                    Als je fiscale partners bent, dan kun je samen aangifte doen of een verzoek voorlopige aanslag doen. Je mag dan bepaalde
                    inkomsten, uitgaven en bezittingen gunstig verdelen. Dit geldt ook voor de ingehouden
                    dividendbelasting.
                    Hierdoor betaal je vaak minder belasting of krijg je (extra) heffingskortingenKortingen op de
                    inkomstenbelasting en premie volksverzekeringen. Welke heffingskortingen je krijgt, hangt af van de
                    persoonlijke situatie.

                    <div class="space20"></div>
                    <b>Fiscaal partnerschap heeft dus gevolgen voor:</b><br>
                    - de hoogte van het inkomen<br>
                    Als aangever en partner in {{ this.actualYear }} fiscale partners zijn, dan mag men
                    bepaalde inkomsten en aftrekposten verdelen zoals men dat
                    wil. Dit geldt ook voor de ingehouden dividendbelasting. Iedere verdeling mag, als het totaal maar
                    100% is. Degene met het hoogste inkomen kan dan bijvoorbeeld de aftrekposten in mindering brengen.
                    <br>
                    - de hoogte van drempelbedragen<br>
                    Als aangever en partner fiscaal partners zijn, dan telt de Belastingdienst de inkomens bij elkaar om
                    de drempelbedragen te berekenen.<br>
                    - heffingskortingen<br>
                    Is de fiscale partner voldoende belasting verschuldigd? En hebt aangever zelf geen of een laag
                    inkomen? Dan betaalt de Belastingdienst onder bepaalde voorwaarden een deel van de heffingskortingen aan de
                    aangever uit.
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse1"
                    aria-expanded="false" aria-controls="collapse1">
                Periode van inschrijving op hetzelfde adres
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse show" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Vul hier de aanvangsdatum en de einddatum in dat de personen ingeschreven staan op hetzelfde woonadres
                staan ingeschreven bij de gemeente. Dit kunnen verschillende adressen zijn, als ze samen verhuizen.
            </div>
        </div>
    </div>

</div>

